module.exports = __webpack_public_path__ + "img/assetBlue.81eac916.png";